function ProjectSkelton() {
    return (
        <div>
            <div className="aspect-video animate-pulse rounded-lg bg-slate-200"></div>
            <div className="p-4">
                <div className="mt-2 h-6 w-56 animate-pulse rounded-md bg-slate-200"></div>
                <div className="mt-2 h-6 w-24 animate-pulse rounded-md bg-slate-200"></div>
            </div>
        </div>
    )
}

export const ProjectsSkeleton = () => {
    return (
        <>
            <div className="mx-auto mt-8 grid grid-cols-1 gap-x-8 gap-y-20 md:mx-0 md:grid-cols-2 xl:grid-cols-3">
                <ProjectSkelton />
                <ProjectSkelton />
                <ProjectSkelton />
            </div>
        </>
    )
}
